import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import "./alert.css";

import logoutUser from "./logoutUser";

function Program({ onNext, onPrev }) {


	const navigate = useNavigate();
	const [selectedProgram, setSelectedProgram] = useState("");
	const [alertData, setAlertData] = useState(null);

	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000); // match your CSS fadeOut timing
	};

	useEffect(() => {
		const fetchProgram = async () => {


			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PROGRAM`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (response.status === 401 || response.status === 403) {

					logoutUser(navigate);
					return;
				}

				if (!response.ok) {
					console.error("Failed to fetch program");
					return;
				}

				//if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("selected program is:", data);

				if (data) {
					setSelectedProgram(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch program", err);
			}
		};

		fetchProgram();
	}, []);

	const handleNext = async () => {
		try {
			const token = sessionStorage.getItem("token"); // 👈 get token

			const response = await fetch(
				`${API_BASE_URL}/API/Student/SAVE_PROGRAM`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + token // 👈 send token
					},
					body: JSON.stringify({
						program: selectedProgram
					})
				}
			);

			if (response.status === 401) {
				sessionStorage.clear();

				showAlert("Session expired ❗ Please login again", "error");

				setTimeout(() => {
					window.location.href = "/ASTU_JMEE_JLEE/Login";
				}, 1000);

				return;
			}

			if (!response.ok) {
				throw new Error("Failed to save program");
			}

			const result = await response.text();
			console.log(result);
			showAlert("Program saved successfully ✅", "success");

			setTimeout(() => {
				onNext();
			}, 800);


		} catch (error) {
			console.error("Error:", error);
			showAlert("Something went wrong while saving program ❗");
		}
	};

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);



			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);
	
	const [isEditOn, setIsEditOn] = useState(false);
	useEffect(() => {
			const checkPaymentStatus = async () => {
				try {
					const token = sessionStorage.getItem("token");

					const response = await fetch(
						`${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
						{
							method: "GET",
							headers: {
								"Authorization": "Bearer " + token
							}
						}
					);

					if (!response.ok) return;

					const result = await response.json(); 
					console.log("edit response:", result);

					setIsEditOn(result);



				} catch (error) {
					console.error("Error checking payment:", error);
				}
			};

			checkPaymentStatus();
		}, []);
		
		//const canEdit = !isPaymentDone || isEditOn === false;
		const canEdit = isEditOn === false;

	return (
		<>
			<style>{`
		
		@keyframes smoothEntry {
		0% {
			opacity: 0;
		    transform: translateY(20px);
     	  }
		100% {
		    opacity: 1;
		    transform: translateY(0);
		  }
		}
		.program-container {
		  background: #ffffff;
		  padding: 20px;
		  border-radius: 12px;
		  border: 1px solid #e2e8f0;
		  font-family: 'Poppins', sans-serif;
		  width: 100%;
		  max-width: 850px;
		  display: flex;
		  flex-direction: column;
		  animation: smoothEntry 0.4s ease;
		}

		.program-title {
		  font-size: 18px;
		  font-weight: 600;
		  color: #1e3a8a;
		  margin-bottom: 15px;
		}

		/* Group */
		.radio-group {
		  display: flex;
		  flex-direction: column;
		  gap: 10px;
		}

		/* 🔥 Row */
		.radio-item {
		  display: flex;
		  align-items: center;
		  gap: 12px;
		  padding: 12px 14px;
		  border: 1px solid #e2e8f0;
		  border-radius: 8px;
		  cursor: pointer;
		  transition: 0.25s;
		  position: relative;
		}

		/* Hover */
		.radio-item:hover {
		  background: #f8fafc;
		}

		/* Active */
		.radio-item.active {
		  background: #eff6ff;
		  border-left: 4px solid #2563eb;
		}

		/* Hide default radio */
		.radio-item input {
		  display: none;
		}

		/* 🔥 Custom radio circle */
		.radio-item::before {
		  content: "";
		  width: 16px;
		  height: 16px;
		  border-radius: 50%;
		  border: 2px solid #94a3b8;
		  display: inline-block;
		}

		/* Selected circle */
		.radio-item.active::before {
		  border: 5px solid #2563eb;
		}

		/* Text */
		.radio-text {
		  font-size: 13px;
		  color: #1e293b;
		  line-height: 1.4;
		}

		/* Footer */
		.footer {
		  display: flex;
		  justify-content: space-between;
		  margin-top: 20px;
		}

		.btn {
		  padding: 8px 16px;
		  border-radius: 6px;
		  border: none;
		  cursor: pointer;
		  font-size: 13px;
		}

		.prev-btn {
		  background: #e2e8f0;
		}

		.next-btn {
		  background: #2563eb;
		  color: white;
		}

		.next-btn:disabled {
		  background: #94a3b8;
		  cursor: not-allowed;
		}
		.radio-item input:disabled + .radio-text {
		  opacity: 0.5;
		  filter: grayscale(100%);
		  cursor: not-allowed;
		}

		/* Also blur the whole row */
		.radio-item:has(input:disabled) {
		  opacity: 0.5;
		  filter: grayscale(100%);
		  cursor: not-allowed;
		  pointer-events: none; /* prevent click */
		}
      `}</style>

			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="program-container">
				<div className="program-title">Select Programme</div>

				<div className="radio-group">

					<label className={`radio-item ${selectedProgram === "JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026" ? "active" : ""}`}>
						<input
							type="radio"
							name="program"
							value="JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026"
							checked={selectedProgram === "JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026"}
							onChange={(e) => setSelectedProgram(e.target.value)}
							disabled={!canEdit}
						/>
						<div className="radio-text">
							JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026
						</div>
					</label>

					<label className={`radio-item ${selectedProgram === "JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026" ? "active" : ""}`}>
						<input
							type="radio"
							name="program"
							value="JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026"
							checked={selectedProgram === "JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026"}
							onChange={(e) => setSelectedProgram(e.target.value)}
							disabled={!canEdit}
						/>
						<div className="radio-text">
							JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026
						</div>
					</label>

				</div>

				{/* 🔥 Footer buttons */}
				<div className="footer">

					{/* Previous */}
					<button className="btn prev-btn" onClick={onPrev}>
						⬅ Previous
					</button>

					{/* Next */}
					<button
						className="btn next-btn"
						disabled={!selectedProgram}
						onClick={handleNext}
					>
						Next ➜
					</button>

				</div>
			</div>

		</>

	);
}



export default Program;